import { useSearchParams } from "react-router-dom";
import JournalDetails from "views/ProjectHome/Journal/JournalDetails";

const JournalDetailsView = () => {
  const [searchParams] = useSearchParams();
  const journalId = searchParams.get("journalId");

  return <JournalDetails selectedRowId={journalId} isFromParams={true} />;
};

export default JournalDetailsView;
